module.exports = __webpack_public_path__ + "static/summit-ba0b0c394fc67a051e4b5ab64fae6906.jpg";